import * as classNames from 'classnames';
import { DataService } from '../../../services/data_service';
import { disableKosten } from '../../../helpers/showKosten';
import { fn2, fn2nZ } from '../../../core/formatter/formatNumber';
import { formStyle, WFormData, WFormFieldArchiv } from '../../../core/forms/WFormFramework';
import { getEmissionsFaktor } from '../../../main/functions/getEmmissionsFaktor';
import { IDs } from '../../../helpers/IDs';
import { isValid as isValidStrom } from '../../../main/functions/validData';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import style from './DialogStromVerbrauch.less';
import { validateFieldStrom } from '../functions/validateField';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { isConfigVorsteuerNetto } from '../co2_custom/getCustomFormConfig';

export interface DialogStromVerbrauchProps {
    data: any;
    standortSelected: any;
    jahr: any;
    values: any;
    onChange: (entityName: string, formValues: any) => void;
    onClose: () => void;
}

export interface DialogStromVerbrauchState {
    data: any;
    showSpinner: boolean;
}

export class DialogStromVerbrauch extends React.Component<DialogStromVerbrauchProps, DialogStromVerbrauchState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            showSpinner: false
        };
        this.onChange = this.onChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;

    private abrechnungsart: number;
    private disableKosten: boolean;
    private disableSpitzenlast: boolean;
    private faktorStromCo2 = getEmissionsFaktor(this.props.data, '', this.props.jahr, 'strom_mix');
    private FormData: any = new WFormData();
    private harmCo2Emissionen: number;
    private maxSpitzenlast: number;
    private sumKosten: number;
    private sumVerbrauch: number;
    private zaehlernummer: string;
    private isVorsteuerNetto: boolean = isConfigVorsteuerNetto(this.props.data);

    componentDidMount(): void {
        const row: any = this.props.values || {};
        const parent_tid = row.tid || 0;
        const zaehler_tid = typeof row.zaehler_tid === 'number'
            ? row.zaehler_tid
            : (typeof row.zaehler_tid_orig === 'number' ? row.zaehler_tid_orig : 0);
        const strom = this.props.data[IDs.ENT_ENERGIEDATEN_STROM] || [];
        const data: any = {};
        strom.filter((item: any) =>
            item.standort_tid_orig === this.props.standortSelected.tid
            && item.jahr === this.props.jahr
            && item.monat >= 1
            // && (item.zaehler_tid_orig || 0) === zaehler_tid
            && item.parent_tid === parent_tid
        ).forEach((item: any) => data[item.monat] = item);
        this.abrechnungsart = row.abrechnungsart || 0;
        this.faktorStromCo2 = +this.faktorStromCo2 > 0 ? this.faktorStromCo2 * 1000000 : this.faktorStromCo2;
        this.disableSpitzenlast = (this.props.data || {}).MODUL_SELECTED === 'cfm';
        this.zaehlernummer = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_STROM}_bundle`] || {}).zaehler_tid || [])
            .find((item: any) => item.tid === zaehler_tid) || {}).zaehlernummer || null;
        this.FormData.setBundle(this.props.data[`${IDs.ENT_ENERGIEDATEN_STROM}_bundle`] || {});
        this.disableKosten = disableKosten(this.props.data);
        this.setState({ data });
    }

    getParentAbrechnungszeitraumBis(rows: any[]): number {
        let az = 0;

        rows.forEach((row: any) => {
            if (!isValidStrom({ ...row, abrechnungsart: this.abrechnungsart }, IDs.ENT_ENERGIEDATEN_STROM)) {
                return;
            }

            if (row.abrechnungszeitraum_bis > 0 && az < row.abrechnungszeitraum_bis) {
                az = row.abrechnungszeitraum_bis;
            }
        });

        return az;
    }

    getParentAbrechnungszeitraumVon(rows: any[]): number {
        let az = 0;

        rows.forEach((row: any) => {
            if (!isValidStrom({ ...row, abrechnungsart: this.abrechnungsart }, IDs.ENT_ENERGIEDATEN_STROM)) {
                return;
            }

            if (row.abrechnungszeitraum_von > 0 && (az === 0 || az > row.abrechnungszeitraum_von)) {
                az = row.abrechnungszeitraum_von;
            }
        });

        return az;
    }

    getValue(value: any): any {
        return typeof value !== 'undefined' && value !== null && !isNaN(+value) ? +value : null;
    }

    onChange(data: any): void {
        const index: number = typeof data.index === 'number' ? data.index : null;
        const value: any = data.value || null;
        const name: string = data.name || (this.state.data[index] || null);
        const values: any = this.state.data;
        values[index] = { ...values[index], [name]: value };
        this.setState({ data: values });
    }

    render(): JSX.Element {
        if (!this.state.data) {
            return null;
        }
        return (
            <div className={classNames(formStyle.sidebysideComplex, style.wrapper)}>
                {/* {this.renderTitle()} */}
                {this.renderHeader()}
                {this.renderVerbraeuche()}
                {this.renderFooter()}
                {this.state.showSpinner && <WSpinner />}
            </div>
        );
    }

    renderButtons(): JSX.Element {
        return (
            <div
                className={style.buttons}
                style={{ width: 250, padding: 0, maxWidth: 'unset' }}
            >
                <WActionButton
                    disabled={this.state.showSpinner}
                    label='Werte speichern und übernehmen'
                    insideText='Werte speichern und übernehmen'
                    key='save'
                    action='save'
                    onAction={() => this.saveData()}
                    styleProps={{
                        width: 245, marginLeft: 3
                    }}
                />
                {/*<WActionButton
                    label='Schließen'
                    insideText='Schließen'
                    key='close'
                    action='delete'
                    onAction={this.props.onClose}
                />*/}
            </div>
        );
    }

    renderFooter(): JSX.Element {
        return (
            <div className={style.footer}>
                <div>Summen</div>
                <div>{fn2(this.sumVerbrauch)}</div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    {fn2nZ(this.sumKosten)}
                </div>
                <div>
                    <span style={{ float: 'left' }}>Mittel</span>
                    {fn2(this.harmCo2Emissionen)}
                </div>
                <div style={this.disableSpitzenlast ? { display: 'none' } : {}}>
                    <span style={{ float: 'left' }}>max.</span>
                    {fn2(this.maxSpitzenlast)}
                </div>
                {this.renderButtons()}
            </div>
        );
    }

    renderHeader(): JSX.Element {
        return (
            <div className={style.header}>
                <div>Monat</div>
                <div>Verbrauch [kWh]</div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    {`Kosten (${this.isVorsteuerNetto ? 'netto' : 'brutto'}) [€]`}
                </div>
                <div>CO₂-Emissionen [gCO₂/kWh]</div>
                <div style={this.disableSpitzenlast ? { display: 'none' } : {}}>Spitzenlast [kW]</div>
                <div>Bemerkung</div>
                <div>Rechnung</div>
                <div style={{ padding: '2px 0' }}>
                    {this.renderHilfeSymbol()}
                </div>
            </div>
        );
    }

    renderHilfeSymbol(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                // styleDivProps={{ display: 'inline-block', marginLeft: -100 }}
                styleDivProps={{ marginTop: 2, marginLeft: -62 }}
                // styleProps={{
                //     width: 18, height: 20, borderRadius: 10, backgroundColor: 'transparent', verticalAlign: 'top', margin: 0
                // }}
                styleProps={{ margin: 0 }}
                label='Rechner - Strom'
                helpKey='dialog_rechner_strom'
                style={'theme_small'}
                type={'theme_info'}
                customElement={'Info'}
                editBar
                useTheme
            />
        );
    }

    renderRow(index: number, isValid: boolean): JSX.Element {
        const values: any = this.state.data[index] || {};
        this.FormData.setAllValues({
            abrechnungsart: this.abrechnungsart,
            bemerkung: values.bemerkung,
            co2_emissionen: (values.co2_emissionen || null) && values.co2_emissionen.toString().length
                ? +values.co2_emissionen
                : this.faktorStromCo2,
            kosten_netto: this.getValue(values.kosten_netto),
            spitzenlast: this.getValue(values.spitzenlast),
            verbrauch_kwh: this.getValue(values.verbrauch_kwh),
            isValid
        });

        return (
            <div className={style.fields}>
                <div>
                    {`${index}/${this.props.jahr}`}
                </div>
                <div>
                    <input
                        name='verbrauch_kwh'
                        type='number'
                        value={values.verbrauch_kwh || (values.verbrauch_kwh === 0 ? 0 : null)}
                        required
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('verbrauch_kwh')}
                </div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    <input
                        name='kosten_netto'
                        type='number'
                        value={values.kosten_netto || (values.kosten_netto === 0 ? 0 : null)}
                        required
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('kosten_netto')}
                </div>
                <div>
                    <input
                        name='co2_emissionen'
                        type='number'
                        placeholder={this.faktorStromCo2 + ''}
                        value={values.co2_emissionen || (values.co2_emissionen === 0 ? 0 : null)}
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('co2_emissionen')}
                </div>
                <div style={this.disableSpitzenlast ? { display: 'none' } : {}}>
                    <input
                        name='spitzenlast'
                        type='number'
                        value={values.spitzenlast || (values.spitzenlast === 0 ? 0 : null)}
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('spitzenlast')}
                </div>
                <div>
                    <input
                        name='bemerkung'
                        type='text'
                        value={values.bemerkung}
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                </div>
                <div>
                    <WFormFieldArchiv
                        entity={IDs.ENT_ENERGIEDATEN_STROM}
                        label={null}
                        name='rechnung'
                        value={values.rechnung || 0}
                        data={values}
                        onValueChange={(name: string, value: any) => {
                            this.onChange({ index, name, value });
                        }}
                        module={IDs.MOD_ETOOL}
                        layout='noneAutoSave'
                    />
                </div>
            </div>
        );
    }

    // renderTitle(): JSX.Element {
    //     return (
    //         <div className={style.title}>
    //             <div>{this.props.jahr}</div>
    //             <div>{this.props.standortSelected.name}</div>
    //             <div>{this.zaehlernummer}</div>
    //             <div style={{ flex: 1, textAlign: 'right' }}>
    //                 <WHelpIcon
    //                     data={this.props.data}
    //                     styleDivProps={{ display: 'inline-block' }}
    //                     styleProps={{
    //                         width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0
    //                     }}
    //                     label='Rechner - Strom'
    //                     helpKey='dialog_rechner_strom'
    //                     type='info'
    //                     editBar
    //                 />
    //             </div>
    //         </div>
    //     );
    // }

    renderValidation(key: string): JSX.Element {
        const { text, type } = this.validateField(key);

        if (!text) {
            return null;
        }

        return (
            <div
                className={formStyle.warnSignDlgRechner}
                style={{ ...(type === 'warning' && { color: '#616468' }) }}
                title={text}
            >
                *
            </div>
        );
    }

    renderVerbraeuche(): JSX.Element[] {
        const rows: JSX.Element[] = [];
        const values: any = this.state.data || {};
        let sumKehrwerte = 0;
        this.harmCo2Emissionen = 0;
        this.maxSpitzenlast = 0;
        this.sumKosten = null;
        this.sumVerbrauch = 0;

        for (let i = 1; i <= 12; ++i) {
            const value: any = values[i] || {};
            const co2_emissionen: number = (
                typeof value.co2_emissionen === 'undefined' || value.co2_emissionen === null || value.co2_emissionen === ''
            )
                ? this.faktorStromCo2
                : +value.co2_emissionen;
            const kosten_netto: number = Math.round((+value.kosten_netto || 0) * 100) / 100;
            const spitzenlast: number = +value.spitzenlast || 0;
            const verbrauch_kwh: number = +value.verbrauch_kwh || 0;
            const isValid: boolean = isValidStrom(
                {
                    abrechnungsart: this.abrechnungsart, co2_emissionen: value.co2_emissionen,
                    kosten_netto: typeof value.kosten_netto !== 'undefined' ? value.kosten_netto : null, spitzenlast: value.spitzenlast,
                    verbrauch_kwh: value.verbrauch_kwh, bemerkung: value.bemerkung
                },
                IDs.ENT_ENERGIEDATEN_STROM
            );
            // console.log('Render Value: ',isValid, value);
            this.sumVerbrauch += isValid ? verbrauch_kwh : 0;
            this.sumKosten = isValid
                ? (value.kosten_netto !== null ? Math.round((+this.sumKosten + kosten_netto) * 100) / 100 : this.sumKosten)
                : this.sumKosten;
            sumKehrwerte += isValid ? verbrauch_kwh * co2_emissionen : 0;

            if (isValid && (spitzenlast > this.maxSpitzenlast)) {
                this.maxSpitzenlast = spitzenlast;
            }
            rows.push(
                <React.Fragment key={`row-${i}`}>{this.renderRow(i, isValid)}</React.Fragment>
            );
        }
        this.harmCo2Emissionen = this.sumVerbrauch ? (sumKehrwerte / this.sumVerbrauch) : 0;

        return rows;
    }

    saveData(): void {
        const datum = new Date().getTime() / 1000;
        const row: any = this.props.values || {};
        const saveList: any[] = [];
        const strom: any[] = this.props.data[IDs.ENT_ENERGIEDATEN_STROM] || [];
        const values: any = this.state.data || {};
        const parent_tid = row.tid || 0;
        const zaehler_tid = typeof row.zaehler_tid === 'number'
            ? row.zaehler_tid
            : (typeof row.zaehler_tid_orig === 'number' ? row.zaehler_tid_orig : 0);
        const data = strom
            ? strom.filter((item: any) =>
                item.standort_tid_orig === this.props.standortSelected.tid
                && item.jahr === this.props.jahr
                && +item.monat >= 1
                // && (item.zaehler_tid_orig || 0) === zaehler_tid
                && item.parent_tid === parent_tid
            ) : [];
        let countValid: number = 0;
        let harmCo2Emissionen = 0;
        let maxSpitzenlast = 0;
        let sumKehrwerte = 0;
        let sumKosten: number = null;
        let sumVerbrauch = 0;

        for (let i = 1; i <= 12; ++i) {
            const value: any = values[i] || {};
            const abrechnungszeitraum_bis = Moment([this.props.jahr, i - 1]).endOf('month').unix();
            const abrechnungszeitraum_von = Moment([this.props.jahr, i - 1]).startOf('month').unix();
            const bemerkung: string = value.bemerkung;
            const co2_emissionen = (
                typeof value.co2_emissionen === 'undefined' || value.co2_emissionen === null || value.co2_emissionen === ''
            )
                ? null
                : +value.co2_emissionen;
            // console.log('S', i , co2_emissionen, value.co2_emissionen);
            const kosten_netto = this.getValue(value.kosten_netto) !== null ? Math.round(value.kosten_netto * 100) / 100 : null;
            const rechnung = +value.rechnung || 0;
            const rechnung_archiv_delete = value.rechnung_archiv_delete || 0;
            const rechnung_archiv_filename = value.rechnung_archiv_filename || null;
            const rechnung_archiv_rawdata = value.rechnung_archiv_rawdata || null;
            const spitzenlast = +value.spitzenlast || 0;
            const verbrauch_kwh = +value.verbrauch_kwh || 0;
            const isValid: boolean = isValidStrom(
                {
                    abrechnungsart: this.abrechnungsart, co2_emissionen: value.co2_emissionen,
                    kosten_netto: typeof value.kosten_netto !== 'undefined' ? value.kosten_netto : null, spitzenlast: value.spitzenlast,
                    verbrauch_kwh: value.verbrauch_kwh, bemerkung: value.bemerkung
                },
                IDs.ENT_ENERGIEDATEN_STROM
            );
            const tid: number = value.tid || null;
            const found = data.find((item: any) => item.tid === (value.tid || null));
            countValid += +isValid;
            sumVerbrauch += isValid ? verbrauch_kwh : 0;
            sumKosten = isValid
                ? (kosten_netto !== null ? Math.round((+sumKosten + kosten_netto) * 100) / 100 : sumKosten)
                : sumKosten;
            sumKehrwerte += isValid
                ? verbrauch_kwh * (co2_emissionen === null ? this.faktorStromCo2 : +co2_emissionen)
                : 0;

            if (isValid && (spitzenlast > maxSpitzenlast)) {
                maxSpitzenlast = spitzenlast;
            }

            if (found) { // Wenn Datensatz schon vorhanden --> immer speichern
                saveList.push({
                    tid,
                    parent_tid,
                    verbrauch_kwh: this.getValue(value.verbrauch_kwh),
                    kosten_netto,
                    co2_emissionen,
                    spitzenlast: this.getValue(value.spitzenlast),
                    rechnung,
                    ...(rechnung_archiv_delete ? { rechnung_archiv_delete } : {}),
                    ...(rechnung_archiv_filename ? { rechnung_archiv_filename } : {}),
                    ...(rechnung_archiv_rawdata ? { rechnung_archiv_rawdata } : {}),
                    bemerkung,
                    datum,
                    zaehler_tid,
                    abrechnungszeitraum_von: found.abrechnungszeitraum_von,
                    abrechnungszeitraum_bis: found.abrechnungszeitraum_bis
                });
            } else if (
                verbrauch_kwh > 0 || kosten_netto > 0 || co2_emissionen > 0 || spitzenlast > 0 || rechnung > 0 || rechnung_archiv_rawdata
            ) {
                const newItem = {
                    parent_tid,
                    ...(this.getValue(value.verbrauch_kwh) !== null ? { verbrauch_kwh } : {}),
                    ...(kosten_netto !== null ? { kosten_netto } : {}),
                    ...(co2_emissionen !== null ? { co2_emissionen } : {}),
                    ...(this.getValue(value.spitzenlast) !== null ? { spitzenlast } : {}),
                    rechnung,
                    ...(rechnung_archiv_delete ? { rechnung_archiv_delete } : {}),
                    ...(rechnung_archiv_filename ? { rechnung_archiv_filename } : {}),
                    ...(rechnung_archiv_rawdata ? { rechnung_archiv_rawdata } : {}),
                    bemerkung,
                    datum,
                    abrechnungszeitraum_von,
                    abrechnungszeitraum_bis,
                    zaehler_tid,
                    jahr: this.props.jahr,
                    monat: i,
                    standort_tid: this.props.standortSelected.tid
                };
                saveList.push(newItem);
            }
        }
        harmCo2Emissionen = +(sumVerbrauch ? (sumKehrwerte / sumVerbrauch) : 0).toFixed(2);

        if (
            this.props.jahr !== Moment().year() && countValid !== 12
            && !window.confirm(`Die Monatsdatensätze (${12 - countValid}/12) wurden nicht vollständig eingegeben, trotzdem speichern?`)
        ) {
            return;
        }

        if (saveList.length > 0) {
            const pAzVon = this.getParentAbrechnungszeitraumVon(saveList);
            const pAzBis = this.getParentAbrechnungszeitraumBis(saveList);
            // Speichere Monatsdaten durch dataService.saveDataList
            this.setState({ showSpinner: true }, () => {
                this.dataService.saveDataList(IDs.ENT_ENERGIEDATEN_STROM, saveList, (sql: string, success: boolean) => {
                    this.setState({ showSpinner: false });
                    this.updateDataGlobal(IDs.ENT_ENERGIEDATEN_STROM, saveList);
                    // Speichere Jahresdaten durch onChange
                    const valueYearFound = strom.find((item: any) => item.tid === row.tid);
                    let valueYear;
                    if (valueYearFound) { // Wenn Datensatz schon vorhanden --> immer speichern
                        valueYear = {
                            tid: valueYearFound.tid,
                            _formKey: row._formKey,
                            verbrauch_kwh: sumVerbrauch,
                            kosten_netto: sumKosten,
                            co2_emissionen: harmCo2Emissionen,
                            spitzenlast: maxSpitzenlast,
                            datum: row.datum,
                            abrechnungszeitraum_von: pAzVon,
                            abrechnungszeitraum_bis: pAzBis,
                            zaehler_tid,
                            jahr: this.props.jahr,
                            standort_tid: this.props.standortSelected.tid
                        };
                        // console.log('Val Year Found', valueYear);
                        this.props.onChange(IDs.ENT_ENERGIEDATEN_STROM, valueYear);
                    } else if (sumVerbrauch > 0 || sumKosten > 0 || harmCo2Emissionen > 0 || maxSpitzenlast > 0) {
                        valueYear = {
                            _formKey: row._formKey,
                            verbrauch_kwh: sumVerbrauch,
                            ...(sumKosten !== null ? { kosten_netto: sumKosten } : {}),
                            co2_emissionen: harmCo2Emissionen,
                            spitzenlast: maxSpitzenlast,
                            datum: row.datum,
                            abrechnungszeitraum_von: pAzVon,
                            abrechnungszeitraum_bis: pAzBis,
                            zaehler_tid,
                            jahr: this.props.jahr,
                            standort_tid: this.props.standortSelected.tid
                        };
                        // console.log('Val Year New', valueYear);
                        this.props.onChange(IDs.ENT_ENERGIEDATEN_STROM, valueYear);
                    }
                    this.props.onClose();
                }, IDs.MOD_ETOOL);
            });
        } else {
            this.props.onClose();
        }
    }

    validateField(key: string): { text: string, type: string } {
        const hasData: boolean = Object.keys(this.FormData.getAllValues()).reduce((hasData: boolean, key: string) =>
            !hasData
                ? key === 'co2_emissionen'
                    ? this.FormData.getValue(key) !== this.faktorStromCo2
                    : this.FormData.getValue(key) !== null
                : true
            , false
        );
        const name: string = (key || '').length
            ? key === 'co2_emissionen'
                ? 'CO₂-Emissionen'
                : key === 'kosten_netto'
                    ? 'Kosten'
                    : key === 'verbrauch_kwh'
                        ? 'Verbrauch'
                        : (key || '').replace(/^\w/, (name: string) => name.toUpperCase())
            : null;
        const value: number = this.FormData.getValue(key);
        let text: string = null;
        let type: string = null;

        if (
            value === null && key !== 'kosten_netto' && key !== 'spitzenlast'
            && (this.props.jahr !== Moment().year() || (this.props.jahr === Moment().year() && hasData))
        ) {
            text = `Bitte Feld "${name}" ausfüllen`;
            type = 'error';
        } else {
            if(!this.FormData.getValue('isValid')) {
                text = validateFieldStrom(key, value, this.FormData, null, this.props.data, (data: any) => type = (data || {}).type || null);
            }
        }

        return { text, type };
    }

    updateDataGlobal(entity: string, rows: any[]) {
        const data = this.props.data[entity];
        if (Array.isArray(data)) {
            rows.forEach((r: any) => {
                if (r.tid > 0) {
                    const idx = data.findIndex((d: any) => d.tid === r.tid);
                    if (idx >= 0) {
                        data[idx] = { ...data[idx], ...r };
                        // console.log('updateDataGlobal', 'tid', entity, data[idx]);
                    }
                } else if (r.parent_tid > 0 && r.monat > 0) {
                    const idx = data.findIndex((d: any) => d.parent_tid === r.parent_tid && d.monat === r.monat);
                    if (idx >= 0) {
                        data[idx] = { ...data[idx], ...r };
                        // console.log('updateDataGlobal', 'parent_tid & monat', entity, data[idx]);
                    } else {
                        data.push(r);
                        // console.log('updateDataGlobal', 'neu', entity, r);
                    }
                }
            });
        }
    }
}
